/* eslint-disable unicorn/consistent-function-scoping */
/* eslint-disable arrow-body-style */
/* eslint-disable react/function-component-definition */
import { Paper } from "@material-ui/core";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  TextField,
  Typography,
} from "@mui/material";
import { useState } from "react";

import { IRevisionLegalComment } from "../../interfaces/IDataComment";
import { RemoveDateFromFileName } from "../../shared/functions";
import Feedback from "../feedback/feedback";
import UploadMultipleFileComponent from "../uploadmultiplefile/UploadMultipleFile";

const ConfirmationDialogRevisionLegal = ({
  open,
  onConfirm,
  onCancel,
  action,
}: {
  open: boolean;
  onConfirm?: (data: IRevisionLegalComment) => void;
  onCancel?: () => void;
  action: string;
}) => {
  const [formData, setFormData] = useState<IRevisionLegalComment>({
    comment: "",
    attachments: [
      {
        title: "Dokumen Tambahan / Additional Document",
        fileType: "Evidence",
        files: [
          { documentID: "", fileBase64: "", fileName: "", folderName: "" },
        ],
      },
    ],
  });
  const [feedbackText, setFeedbackText] = useState("");
  const [feedbackType, setFeedbackType] = useState("");
  const [openFeedback, setOpenFeedback] = useState(false);
  const [errorUpload, setErrorUpload] = useState("");
  const [isUploadAttach, setIsUploadAttach] = useState(false);

  const handleChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      comment: e.target.value,
    }));
  };

  const getBase64 = (file: any) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.addEventListener("load", () => {
        resolve(reader.result);
      });
      reader.addEventListener("error", (error) => {
        reject(error);
      });
      reader.readAsDataURL(file);
    });

  const handleChangeUpload = async (data, dataIndex, fileIndex) => {
    if (data != undefined) {
      if (data.name.length > 150) {
        setFeedbackText("File name cannot be more than 150 letters!");
        setFeedbackType("failed");
        setOpenFeedback(true);
        setTimeout(() => {
          setOpenFeedback(false);
        }, 2000);
        return;
      }
      const resultBase64File: any = await getBase64(data).then(
        (bs64: any) => bs64
      );

      const newFileNameWithoutDate = RemoveDateFromFileName(data.name);
      const filteredSameFileName = !formData.attachments.some((item) =>
        item.files.some((file) => {
          const existingFileNameWithoutDate = RemoveDateFromFileName(
            file.fileName
          );
          return existingFileNameWithoutDate === newFileNameWithoutDate;
        })
      );

      if (filteredSameFileName) {
        setFormData((prev) => {
          const newAttachments = [...prev.attachments];
          newAttachments[dataIndex] = {
            ...newAttachments[dataIndex],
            files: [...newAttachments[dataIndex].files],
          };
          newAttachments[dataIndex].files[fileIndex] = {
            documentID: "",
            fileBase64: resultBase64File,
            fileName: data.name,
            folderName: "",
          };
          return {
            ...prev,
            attachments: newAttachments,
          };
        });
        setIsUploadAttach(true);
        setErrorUpload("");
      } else {
        setFeedbackText("The file already exists, please change the file name");
        setFeedbackType("failed");
        setOpenFeedback(true);
        setTimeout(() => {
          setOpenFeedback(false);
        }, 2000);
      }
    }
  };

  const handleChangeDelete = (dataIndex: number, fileIndex: number) => {
    setFormData((prev) => {
      const newAttachments = [...prev.attachments];
      newAttachments[dataIndex] = {
        ...newAttachments[dataIndex],
        files: [...newAttachments[dataIndex].files],
      };
      newAttachments[dataIndex].files[fileIndex] = {
        documentID: "",
        fileBase64: "",
        fileName: "",
        folderName: "",
      };
      return {
        ...prev,
        attachments: newAttachments,
      };
    });
    setIsUploadAttach(false);
  };

  const handleChangeDownload = (dataIndex, fileIndex) => {
    const downloadLink = document.createElement("a");
    const file = formData.attachments[dataIndex].files[fileIndex];
    if (file.fileBase64 != "") {
      downloadLink.href = file.fileBase64;
      downloadLink.download = file.fileName;
      downloadLink.click();
    }
  };

  return (
    <Dialog open={open}>
      <Paper
        style={{
          width: "600px",
          padding: "25px",
        }}
      >
        <DialogContent>
          <Box
            component="form"
            sx={{
              "& .MuiTextField-root": { width: "100%", marginBottom: "2%" },
            }}
            noValidate
            autoComplete="off"
          >
            <Typography
              variant="subtitle1"
              gutterBottom
              style={{ float: "left" }}
            >
              <u>
                Catatan / <i>Note</i>
              </u>
            </Typography>
            <Typography
              variant="subtitle1"
              gutterBottom
              style={{ float: "right" }}
            >
              {action}
            </Typography>
            <TextField
              multiline
              maxRows={1}
              onChange={handleChange}
              value={formData.comment}
            />
            {isUploadAttach && formData.comment.trim() === "" && (
              <div className="error-message" style={{ marginBottom: "2%" }}>
                Please input note, because you upload attachment
              </div>
            )}
          </Box>
          {formData.attachments.map((obj, i) => (
            <div>
              <UploadMultipleFileComponent
                file={obj}
                fileIndex={i}
                onUploadFile={(data, fileIndex) => {
                  handleChangeUpload(data, i, fileIndex);
                }}
                onDeleteFile={(fileIndex) => handleChangeDelete(i, fileIndex)}
                onDownloadFile={(fileIndex) => {
                  handleChangeDownload(i, fileIndex);
                }}
                onAddMoreData={() => {
                  if (formData.attachments[i].files.length < 5) {
                    setFormData((prevState) => {
                      const newState = { ...prevState };
                      const emptyFile = {
                        documentID: "",
                        fileBase64: "",
                        fileName: "",
                        folderName: "",
                      };
                      newState.attachments[i].files.push(emptyFile);
                      return newState;
                    });
                  }
                }}
                onDeleteData={(ind) => {
                  setFormData((prevState) => {
                    const newState = { ...prevState };
                    if (
                      i >= 0 &&
                      i < newState.attachments.length &&
                      ind >= 0 &&
                      ind < newState.attachments[i].files.length
                    ) {
                      newState.attachments[i].files.splice(ind, 1);
                    }
                    return newState;
                  });
                }}
                requiredValidationMessage={errorUpload}
              />
            </div>
          ))}
          <Feedback
            open={openFeedback}
            message={feedbackText}
            feedbackType={feedbackType}
          />
        </DialogContent>
        <DialogActions sx={{ justifyContent: "space-evenly" }}>
          {onCancel && (
            <Button
              sx={{ background: "#898989", width: "50%" }}
              variant="contained"
              onClick={() => {
                onCancel();
                setFormData((prev) => ({ ...prev, comment: "" }));
              }}
              color="primary"
            >
              Cancel
            </Button>
          )}
          {onConfirm && (
            <Button
              sx={{ width: "50%" }}
              variant="contained"
              onClick={() => onConfirm(formData)}
              color="primary"
              autoFocus
            >
              OK
            </Button>
          )}
        </DialogActions>
      </Paper>
    </Dialog>
  );
};

export default ConfirmationDialogRevisionLegal;
